import {match} from 'ts-pattern';

import {AdServer} from '../types/AdServer';

export const mapMarketToAdServer = (market: string): AdServer[] =>
  match(market)
    .with('CZE', () => [AdServer.SAUTO])
    .with('DEU', () => [AdServer.MOBILE_DE])
    .with('POL', () => [AdServer.OTOMOTO])
    .with('AUT', () => [AdServer.AUTOSCOUT24])
    .with('ITA', () => [AdServer.AUTOSCOUT24])
    .with('SVK', () => [AdServer.AUTOBASAR])
    .with('FRA', () => [AdServer.LA_CENTRALE])
    .with('SWE', () => [AdServer.BLOCKET])
    .with('ROU', () => [AdServer.AUTOVIT])
    .with('BEL', () => [AdServer.AUTOSCOUT24, AdServer.TWODEHANDS])
    .with('NLD', () => [AdServer.AUTOSCOUT24])
    .with('LUX', () => [AdServer.LUXAUTO])
    .otherwise(() => [AdServer.MOBILE_DE]);
